import React, { Component, useState, useEffect } from "react";
import Table from "view/component/Table";
import * as XLSX from "xlsx";
import moment from "moment";
import { date } from "yup";
import apiService from "apiService";
import { toast } from "view/component/Alert";
import Export from "view/dinas/laporan/components/Export";

const groupBy = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

const ImportDataTb = (props) => {
  let header = JSON.parse(localStorage.getItem("puskesmasProfile"));
  const [datas, setdatas] = useState([]);
  const [flags, setFlags] = useState("");
  const [puskesmas, setPuskesmas] = useState('');
  const [refPuskesmas, setrefPuskesmas] = useState([]);

  const [refKecamatan, setRefKecamatan] = useState([]);
  const [refDesa, setRefDesa] = useState([]);
  const [refDusun, setrefDusun] = useState([]);
  const [demographicData, setDemographicData] = useState({
    province: 34,
    cities: 3404,
    districts: "",
    villages: "",
    dusun: "",
  });
  const [status, setStatus] = useState(false);

  useEffect(() => {
    getDistrict();
  }, [refKecamatan.length]);

  useEffect(() => {
    let kec = refKecamatan.find((e) => e.id == demographicData.districts);
    let desa = kec ? kec.villages : [];
    setRefDesa(desa);
  }, [demographicData.districts]);

  useEffect(() => {
    setDemographicData({ ...demographicData, dusun: '' })
    getDusun();
  }, [demographicData.villages]);

  const getDistrict = async () => {
    const res = await apiService.get("/demograph/cities/find/3404");
    if (res?.code === 200) {
      setRefKecamatan(res.data.districts);
    }
  };

  const getDusun = async () => {
    const param = {
      villages: [demographicData.villages],
    };
    const res = await apiService.post("/demograph/dusun/find", param);
    if (res?.code === 200) {
      setrefDusun(res.data);
    }
  };

  const onChangeDemograph = (event) => {
    const value = event.target.value;
    const object = event.target.name;

    setDemographicData({
      ...demographicData,
      [object]: value,
    });
  };

  const readFile = (e) => {
    e.stopPropagation();
    e.preventDefault();
    var f = e.target.files[0];
    var name = f.name;
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 2 });
      if (convertToJson(data).length > 0) {
        // let d = groupBy(convertToJson(data), 'nik');
        // let group = Object.keys(d);
        setdatas(convertToJson(data), 'asdas');
        console.log(datas);

      }
    };
    reader.readAsBinaryString(f);
  };
  const convertToJson = (csv) => {
    var lines = csv.split("\n");
    var result = [];
    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(";");
      let dat = currentline[0].split(",");
      try {
        if (dat.length > 0 && dat[0] !== "") {
          obj["kd_puskesmas"] = puskesmas;
          obj["nik"] = dat[2].match(/\d/g).join("");
          obj["tgl_daftar"] = dat[1];
          obj["name"] = dat[3];
          obj["sex"] = dat[5];
          obj["faskes"] = puskesmas;
          obj["usia"] = dat[6];
          obj["address"] = dat[7];
          result.push(obj);
        }
      } catch (error) {
        console.log(error, dat)
      }
    }
    //return result; //JavaScript object
    return result; //JSON
  };

  const postImport = async () => {
    setStatus(true);
    toast({ status: "info", text: "Data Diproses" });
    let par = {
      data: datas,
      status: flags,
      dusun: demographicData.dusun == "" ? null : demographicData.dusun,
      desa: demographicData.districts,
    };
    setStatus(false);
    let res = await apiService.post("/tb/import", par);
    if (res && res.code === 200) {
      toast({ status: "success", text: "Data Berhasil di import" });
      if (res.data.err && res.data.err.length > 0) {
        toast({ status: "error", text: "Beberapa Data gagal Masuk silahkan cek kembali sesuai di tabel" });
        let dat = [];
        res.data.err.map(a => {
          dat.push(a.data)
        })
        setdatas(dat);
      } else {
        setdatas([]);
      }
      setStatus(false);
    } else {
      toast({ status: "error", text: "Data Gagal diimport" });
      setStatus(false);
    }
  };

  const fetchPuskesmasProfile = async () => {
    try {
      const res = await apiService.get('/management/profiles/read');
      if (res.code === 200) {
        setrefPuskesmas(res.data)
      }
    } catch (error) {
      setrefPuskesmas([]);

    }
  };
  useEffect(() => {
    fetchPuskesmasProfile()
  }, [refPuskesmas.length])


  return (
    <div>
      <div className="main-content mt-4">
        <div className="container-fluid">
          <div className="row">
            <div className="card col-md-12">
              <div className="card-header text-center">
                <div className="h3 mb-2">
                  IMPORT DATA TB {header?.report_header_1}
                </div>
                <div className="h3 mb-2">{header?.name?.toUpperCase()}</div>
                <div className="mt-5 row c0l-md-12">
                  <div className="form-group col-md-6 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Kecamatan
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className={"form-control form-control-sm"}
                          name="districts"
                          id="kecamatan"
                          value={demographicData.districts}
                          onChange={(e) => onChangeDemograph(e)}
                        >
                          <option>-</option>
                          {refKecamatan.map((data, k) => (
                            <option key={k} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-md-6 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Desa
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm "
                          id="example-text-input"
                          name="villages"
                          onChange={(e) => onChangeDemograph(e)}
                          value={demographicData.villages}
                        >
                          <option>pilih data ...</option>
                          {refDesa.map((data, k) => (
                            <option key={k} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-md-6 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Dusun
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm "
                          id="example-text-input"
                          name="dusun"
                          onChange={(e) => onChangeDemograph(e)}
                          value={demographicData.dusun}
                        >
                          <option>pilih data ...</option>
                          {refDusun.map((data, k) => (
                            <option key={k} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                        {/* {errors.vaccine_receiver_category_id && touched.vaccine_receiver_category_id ? (
                                                    <div style={{ color: "red" }}>&nbsp; {errors.vaccine_receiver_category_id}</div>
                                                ) : null} */}
                      </div>
                    </div>
                  </div>
                  <div className="form-group col-md-6 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      Status Screening
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        <select
                          className="form-control form-control-sm "
                          id="example-text-input"
                          name="flags"
                          onChange={(e) => setFlags(e.target.value)}
                          value={flags}
                        >
                          <option>pilih data ...</option>
                          <option value={"Terduga"}>Terduga.</option>
                          <option value={"Tak Terduga"}>Tak Terduga</option>
                          <option value={"Positif"}>Positif</option>
                        </select>
                        {/* {errors.flags && touched.flags ? (
                                                    <div style={{ color: "red" }}>&nbsp; {errors.flags}</div>
                                                ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group col-md-6 row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Puskesmas
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <select
                        className="form-control form-control-sm "
                        id="example-text-input"
                        name="puskesmas"
                        onChange={(e) => setPuskesmas(e.target.value)}
                        value={puskesmas}
                      >
                        <option>pilih data ...</option>
                        {refPuskesmas.map((data, k) => (
                          <option key={k} value={data.code}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row pt-2">
                  <div className="form-group col-md-6 m-0">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text text-default">
                          Pilih File Upload
                        </span>
                      </div>
                      <input
                        className="form-control"
                        type="file"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={(e) => {
                          readFile(e);
                          e.target.value = null;
                        }}
                        disabled={puskesmas ? false : true}
                      />
                    </div>
                  </div>
                  <div>
                    <button
                      className="btn btn-primary"
                      disabled={status}
                      onClick={(e) => postImport()}
                    >
                      {" "}
                      {status ? "Sedang Memproses Data" : "Import Data"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  headers={[
                    "No",
                    "Status",
                    "Faskes",
                    "Tgl",
                    "NIK",
                    "Nama",
                    "Jenis Kelamin",
                    "usia",
                    "address",
                  ]}
                  data={datas}
                  columnMapper={(data, key) => [
                    data.upload_status ? data.upload_status : "Berhasil Dibaca",
                    data.kd_puskesmas,
                    data.tgl_daftar,
                    data.nik,
                    data.name,
                    data.sex,
                    data.usia,
                    data.address,
                  ]}
                  pagination={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};

export default ImportDataTb;
